import StringUtil from './StringUtil';
export default class Fade{

	

	static show(options){
	
		var defaults = {
			state:"info",
		 	backgroundColor:'#ffffff',
		 	color:"#fff",
		 	duration:2000,
		 	pause:2000,
		 	fontSize:'20px',
		 	text:"操作成功！",
		 	cornerRadius:"10",
		 	interacdestroy:false,
			fademodalmask: true,
			zindex:1050
		}

		// var stateColor={
		// 	info:'alert-info',
		// 	warn:'alert-warning',
		// 	error:'alert-danger',
		// 	success:'alert-success'
		// }
		var stateStyle={
			info:{
				width:'31px',
				fontSize:'31px',
				color:'#2196F3'
			},
			warn:{
				width:'31px',
				fontSize:'31px',
				color:'#F5A623'
			},
			error:{
				width:'31px',
				fontSize:'31px',
				color:'#EA1E1E'

			},
			success:{
				width:'31px',
				fontSize:'31px',
				color:'#26BD71'
			}
		}
		var stateIcon={
			info:"fa fa-info-circle",
			warn:"fa fa-exclamation-circle",
			error:"fa fa-times-circle",
			success:"fa fa-check-circle"
		}
		
		$.extend(true, defaults, options);
		
		if(defaults.interacdestroy){
			$(document).on("mousedown", function(e) {
				if($(alertDiv)){
					if(!($(alertDiv).is(e.target))){
						$(document).off("mousedown");
						$(alertDiv).remove();
						if(typeof(window.restoreLastFocus) == "function")
							window.restoreLastFocus();
					}
				}
			});
		}

		var maskbackground = "rgba(0, 0, 0, 0.3);";
		if(!defaults.fademodalmask){
			maskbackground = "none"
		}


		var titleMsg={
			info:'提示',
			warn:'警告',
			error:'错误',
			success:'成功'
		}

		var titleIcon=$('<i style="margin-right:10px"></i>').addClass(stateIcon[defaults.state]).css(stateStyle[defaults.state]);
  		var titleH=$('<h4></h4>').addClass('modal-title').css({'font-weight':'700'}).append(titleMsg[defaults.state]);//判断显示内容
  		
  		var headerDiv=$('<div></div>').addClass('modal-header').append(titleH);

  		var bodyP=$('<p></p>').html(defaults.text).css({'font-size':defaults.fontSize,'margin-bottom':'0px'});
		if(typeof defaults.color == 'number'){
			bodyP.css("color","#" + defaults.color.toString(16).toUpperCase().padStart(6, '0'))
		}
  		var bodyDiv=$('<div></div>').addClass('modal-body').append(titleIcon).append(bodyP).css({'min-height':'105px','display':'flex','align-items':'center','padding-top':'10px','padding-bottom':'10px'});
  		
  		
  			
  		var contentDiv=$('<div></div>').addClass('modal-content').append(headerDiv).append(bodyDiv).css({background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'});
		if(defaults.cornerRadius!="10"){
			contentDiv.css("borderRadius",defaults.cornerRadius+"px");
		}

  		var dialogDiv=$('<div></div>').append(contentDiv).css({'margin':'18% auto','position':'relative','width':'508px','min-width':'475px'});

  		var alertDiv = $('<div id="fademodal"></div>').addClass('modal').append(dialogDiv).css({"background":maskbackground,"z-index":defaults.zindex});
  		//parent.$("body").append(alertDiv);


		if(window.isSelfFrameRoot == true)
		{
			$("body").append(alertDiv);
		}
		else
		{
			parent.$("body").append(alertDiv);
		}











  // 		var alertIcon=$("<i></i>").addClass("icon fa").addClass(stateIcon[defaults.state]);
  // 		var alertDiv=$("<div></div>").addClass('alert alert-dismissible').append(alertIcon).append(defaults.text)
  // 			.css({'color':defaults.color,'border-radius':defaults.cornerRadius,'position':'absolute',
  // 				'z-index':'3000','top':'40%','left':'40%','width':'20%','padding':'20px',
  // 				'text-align':'center','display':'none','font-size':'24px'
  // 			})

  // 		if(defaults.backgroundColor){
		// 	alertDiv.css("background-color",defaults.backgroundColor)
		// }else{
		// 	alertDiv.addClass(stateColor[defaults.state])
		// }
  		
  // 		$('body').append(alertDiv);
		if(defaults.backgroundColor)
		{
			let _backgroundColor = typeof(defaults.backgroundColor) == "number"?("#"+StringUtil.toColorStyleString(defaults.backgroundColor)):defaults.backgroundColor;
			$(contentDiv).css("background-color",_backgroundColor);
		}
		if(window.fadeduration){
			$(alertDiv).fadeIn(window.fadeduration);
		}else{
			$(alertDiv).fadeIn(defaults.duration);
		}

		//鼠标点击后立刻去除弹出框
		if (defaults.interacdestroy == false)
		{
			try
			{
				let mousedownHandler = window.parent.window.document;
				if(window.didomain)
					mousedownHandler = window.document;
				$(mousedownHandler).on("mousedown", function (e) {
					if($(alertDiv)){
						// if(!($(alertDiv).is(e.target))){
							$(mousedownHandler).off("mousedown");
							$(alertDiv).remove();
							if(typeof(window.restoreLastFocus) == "function")
								window.restoreLastFocus();
						// }
					}
				});
			}
			catch(e)//如果存在跨域引入等问题
			{
				$(window.document).on("mousedown", function (e) {
					if($(alertDiv)){
						// if(!($(alertDiv).is(e.target))){
							$(document).off("mousedown");
							$(alertDiv).remove();
							if(typeof(window.restoreLastFocus) == "function")
								window.restoreLastFocus();
						// }
					}
				});
			}
			
		}

		var pausetime = defaults.pause;
		if(window.fadepause){pausetime = window.fadepause}
		var t=setTimeout(function() {
			//alert("去掉");
			if(window.fadepause){
				$(alertDiv).fadeOut(window.fadepause);
			}else{
				$(alertDiv).fadeOut(defaults.pause);
			}

			if(defaults.interacdestroy){
				$(document).off("mousedown");
				$(alertDiv).remove();
				if(typeof(window.restoreLastFocus) == "function")
					window.restoreLastFocus();
			}
			

		},pausetime)
		
		
	}

    

}


// WEBPACK FOOTER //
// ./src/utils/Fade.js